module.exports = __webpack_public_path__ + "mrstaticmedia/2-2@2x.27d0afd7.png";